const SESSION_COOKIE_NAME = 'nm-onboarding';
const SESSION_COOKIE_EXPIRE_IN_S = 48 * 60 * 60;
const SESSION_COOKIE_EXPIRE_IN_MS = SESSION_COOKIE_EXPIRE_IN_S * 1000;
// extract 'container_name' out of 'https://xyz.com/container_name/some_path'

const REACT_APP_MOUNT = process.env.REACT_APP_MOUNT;

const SESSION_COOKIE_PATH = '/' + ((REACT_APP_MOUNT || '/').replace(/^https*:\/\/[^/]+/i, '').split('/')[1] || '');

module.exports = {
    SESSION_COOKIE_NAME,
    SESSION_COOKIE_EXPIRE_IN_S,
    SESSION_COOKIE_EXPIRE_IN_MS,
    SESSION_COOKIE_PATH,
}